// SignIn
// import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Button from '../../components/design/buttons/Button';
// import Card from '../../components/design/cards/card';
// import Header from '../../components/header/header';
// import Footer from '../../components/footer/footer';
// import './Page.css'
// import React from 'react';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { createAccount, getProfile, loginAccount, sendOtpEmail, sendOtpPhoneNumber, updateEmail, updatePhoneNumber, updateProfile, verifyCode } from "../../../services/accounts.service";
import Button from "../../../components/design/buttons/Button";
import Footer from "../../../components/footer/footer";
import { Modal } from "react-bootstrap";
import Header from "../../../components/header/header";
import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import "./ProfileSettings.css";
import Card from "../../../components/design/cards/card";
import i18n from "../../../../config/i18n";

const ProfileSettings = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [gender, setGender] = useState<string>("NotUpdated");
    const [dateOfBirth, setDateOfBirth] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");
    const [phoneError, setPhoneError] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const navigate = useNavigate();
    const [otp, setOtp] = useState<boolean>(false);
    const [otpMethod, setOtpMethod] = useState<string>("PhoneNumber");
    const [old_phone, setOldPhone] = useState<string>("");
    const [old_email, setOldEmail] = useState<string>("");

    useEffect(() => {
        // Load user data from localStorage
        fetchingUserProfile();
    }, []);

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }
    const validatePhone = (phone: string) => {
        // Step 1: Remove non-digit characters
        let cleanPhone = phone.replace(/\D/g, "");

        // Step 2: Remove leading '0' if present
        if (cleanPhone.startsWith("0")) {
            cleanPhone = cleanPhone.slice(1);
        }

        // Step 3: Check if it's exactly 9 digits now
        const re = /^[0-9]{9}$/;
        return re.test(cleanPhone);
    };



    const updateEmailSubmit = async () => {
        let hasError = false;

        // if ((old_phone === "" && phone != old_phone)) {
        //     setPhoneError(t("store.register.phone_error") || "");
        //     hasError = true;
        // }
        if (email === "" && email != old_email) {
            setEmailError(t("store.register.email_error_required") || "");
            hasError = true;
        }
        if (!validateEmail(old_email)) {
            setEmailError(t("store.register.email_error_invalid") || "");
            hasError = true;
        }
        // if (old_phone.length < 10 && phone != old_phone) {
        //     setPhoneError(t("store.register.phone_error_invalid") || "");
        //     hasError = true;
        // }

        

        if (hasError) return;
        if(email != old_email) {
            // Call the API to send OTP for email verification
              sendOtpEmail({
                  email: old_email,
              }).then ((res) => {
                  setOtpMethod("Email");
                  setOtp(true);
              })
              .catch((err) => {
                  console.error("Error sending OTP for email:", err);
                  toast.error(t("store.otp.email_error") || "Failed to send OTP for email");
                  throw new Error(err.response?.data?.message || "Failed to send OTP for email");
              });
          }
        //   if(phone != old_phone) {
        //     // Call the API to send OTP for phone number verification
        //     sendOtpPhoneNumber({
        //       phoneNumber: old_phone,
        //       countryCode: "966", // Assuming country code is always 966
        //     }).catch((err) => {
        //       console.error("Error sending OTP for phone number:", err);
        //       throw new Error(err.response?.data?.message || "Failed to send OTP for phone number");
        //   });
        //       setOtpMethod("PhoneNumber");
        //       setOtp(true);
        //   }
    }

    const updatePhoneSubmit = async () => {
        let hasError = false;

    //    if (old_phone === "" && phone != old_phone) {
    //        setPhoneError(t("store.register.phone_error") || "");
    //        hasError = true;
    //    }
       if (!validatePhone(old_phone)) {
           setPhoneError(t("store.register.phone_error_invalid") || "");
           hasError = true;
       }

        if (hasError) return;
        if(phone != old_phone) {
            // Call the API to send OTP for phone number verification
            sendOtpPhoneNumber({
                phoneNumber: old_phone.replace(/\D/g, ""),
                countryCode: "966", // Assuming country code is always 966
            }).then ((res) => {
                setOtpMethod("PhoneNumber");
                setOtp(true);
            })
            .catch((err) => {
                console.error("Error sending OTP for phone number:", err);
                toast.error(t("store.otp.phone_error") || "Failed to send OTP for phone number");
                throw new Error(err.response?.data?.message || "Failed to send OTP for phone number");
            });
        }
    }
    const updateProfileSubmit = async () => {
        setNameError("");
        setPhoneError("");
        setEmailError("");
        setError("");
        
        let hasError = false;

        if (name === "") {
            setNameError(t("store.register.name_error") || "");
            hasError = true;
        }
       
        setLoading(true);
        try {
            // Simulate an API call
            // 1- This is for retrieving the user profile: https://test.accounts.tygo.net:443/api/User/GetProfile
            // 2- This is for updating the (first and last names + DOB + Gender): https://test.accounts.tygo.net:443/api/User/UpdateProfile
            // 3- To update the email or phone number, you must first call sendOtp endpoint (email has its own endpoint, and phone number has its own separate endpoint) (check image).
                        // Here you would typically make an API call to update the user's profile

            

            //updateProfile
            const response = await updateProfile({
                firstName: name.split(" ")[0] || "",
                lastName: name.split(" ")[1] || "", 
                dateOfBirth: dateOfBirth || "",
                gander: gender || "",
            }).catch((err) => {
                console.error("Error updating profile:", err);
                throw new Error(err.response?.data?.message || "Failed to update profile");
            });


            console.log("Response from updateProfile:", response);
            

            const user = JSON.parse(localStorage.getItem("tygo_user") || "{}");
            const updatedUser = {
                ...user,
                name,
                gender,
                dateOfBirth,
            };
            localStorage.setItem("tygo_user", JSON.stringify(updatedUser));
            
            toast.success(t("profile.update_success") || "Profile updated successfully");
            setLoading(false);
        } catch (err: any) {
            setError(err.message || "Failed to update profile");
            setLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("tygo_user");
        navigate("/login2");
    };

    const fetchingUserProfile = async () => {
        setLoading(true);
        try {
            const response = await getProfile();
            console.log("Response from getProfile:", response);
            if (response.status === 200) {
                const data = await response.data;
                
                // Handle name concatenation with null check
                const fullName = [data.firstName, data.lastName]
                    .filter(Boolean)  // Remove null/undefined values
                    .join(" ")
                    .trim();
                setName(fullName);

                // Handle other fields with null checks
                setEmail(data.email || "");
                setPhone(data.phoneNumber || "");
                setOldPhone(data.phoneNumber || "");
                setOldEmail(data.email || "");
                
                // Convert date format from "2001-01-01T00:00:00" to "2001-01-01"
                if (data.dateOfBirth) {
                    const birthDate = new Date(data.dateOfBirth).toISOString().split('T')[0];
                    setDateOfBirth(birthDate);
                } else {
                    setDateOfBirth("");
                }

                // Note: API returns "gander" instead of "gender"
                setGender(data.gander); // Adjusted to handle null/undefined
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
            toast.error(t("profile.fetch_error") || "Failed to fetch profile data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{backgroundImage: "url(./media/hero/bg2.png)", backgroundColor:"#F7F7F7",minHeight:"100vh",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundAttachment: "fixed"
        }} className="d-flex flex-column justify-content-between">
           <div className="container">
           <Header />
            <Card noEdge inner={
            <div className="container h-100">
                <div className="card_form">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1 className="m-0">
                            {t("profile.my_account") || "My Account"}
                        </h1>
                        <div className="d-flex gap-2">
                            <Button 
                                inner={t("profile.logout") || "Logout"}
                                color="secondary"
                                onClick={handleLogout}
                            />
                            <Button 
                                inner={t("profile.save") || "Save"}
                                color="primary"
                                onClick={updateProfileSubmit}
                                isLoading={loading}
                            />
                        </div>
                       
                    </div>

                    <div className="row payment_row my-3">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="name">{t("profile.full_name") || "Full Name"}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    value={name}
                                    onChange={(e) => setName(e.target.value)} 
                                />
                            </div>
                            <p className="text-danger">{nameError}</p>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="email">{t("profile.email") || "Email"}</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    value={old_email}
                                    onChange={(e) => {setOldEmail(e.target.value); setEmailError("")}} 
                                />
                            </div>
                            {
                                email !== old_email && (
                                    <div className="d-flex flex-row mt-3 align-items-start gap-4">
                                    <span className="text-warning">{t("profile.email_change_warning") || "Email has changed. Please verify."}</span>
                                    <Button 
                                        inner={t("profile.update_email") || "Update Email"}
                                        color="primary p-0 px-3"
                                        onClick={updateEmailSubmit}
                                    />
                                    </div>
                                )}
                            
                            <p className="text-danger">{emailError}</p>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="phone">{t("profile.phone") || "Phone Number"}</label>
                                <input 
                                    type="tel" 
                                    className="form-control" 
                                    value={old_phone}
                                    onChange={(e) => {
                                        setOldPhone(e.target.value)
                                        setPhoneError("")
                                    }}
                                />
                            </div>
                            {
                                phone !== old_phone && (
                                    <div className="d-flex flex-row mt-3 align-items-start gap-4">
                                    <span className="text-warning">{t("profile.phone_change_warning") || "Phone number has changed. Please verify."}</span>
                                    <Button 
                                        inner={t("profile.update_phone") || "Update Phone"}
                                        color="primary p-0 px-3"
                                        onClick={updatePhoneSubmit}
                                    />
                                    </div>
                                )
                            }
                            <p className="text-danger">{phoneError}</p>
                        </div>
                        
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="gender">{t("profile.gender") || "Gender"}</label>
                                <select 
                                    className="form-control" 
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                >
                                    <option value="NotUpdated">{t("profile.select_gender") || "Select Gender"}</option>
                                    <option value="Male">{t("profile.male") || "Male"}</option>
                                    <option value="Female">{t("profile.female") || "Female"}</option>

                                </select>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="dateOfBirth">{t("profile.date_of_birth") || "Date of Birth"}</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={dateOfBirth}
                                    onChange={(e) => setDateOfBirth(e.target.value)} 
                                />
                            </div>
                        </div>
                    </div>
                    <p className="text-danger">{error}</p>
                </div>
            </div>}
            />
           </div>
            <Footer />
             <Modal show={otp} onHide={() => setOtp(false)} className="modal_store_info" style={
                                                {
                                                    direction: i18n.language === "ar" ? "rtl" : "ltr"
                                                }
                                            }>
                                                <Modal.Header closeButton  style={{
                                                        border: "none",
                                                        padding: "0",
                                                        width: "100%"
                                                    }}>
                                                <Modal.Title>{t('store.otp.title')}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <OtpForm setState={setOtp} method={otpMethod} emailOrPhone={otpMethod === "Email" ? old_email :old_phone} />
                                                </Modal.Body>
                                            </Modal>
                                            
        </div>
    );
};

export default ProfileSettings;
 const OtpForm = ({setState, method, emailOrPhone} : {setState: any, method: string, emailOrPhone: string}) => {
        const {t, i18n} = useTranslation();
        const [error, setError] = useState<string>("");
        const [loading, setLoading] = useState<boolean>(false);
        const [otp, setOtp] = useState(["", "", "", ""]);
        const inputRefs = useRef([...Array(4)].map(() => React.createRef())) as any;
        // const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
        const navigate = useNavigate();
        const [counter, setCounter] = useState<number>(60);
        const handleOtpChange = (index: number, value: string) => {
          if (value === "") {
            const newOtp = [...otp];
            newOtp[index] = "";
            setOtp(newOtp);
      
            if (index > 0) {
              inputRefs.current[index - 1].current.focus();
            }
          } else if (+value >= 0 && +value <= 9) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
      
            if (index < otp.length - 1) {
              inputRefs.current[index + 1].current.focus();
            }
          }
            if (index === otp.length - 1 && value !== "") {
                const otpValue = otp.join("");
                console.log(otpValue);
                const newOtp = [...otp];
                newOtp[index] = value;
             
                verify(newOtp.join(""));
            }
        };
        const [otptype, setOtpType] = useState<string>("PhoneNumber");
        const handleKeyDown = (index: number, e: any) => {
          if (e.key === "Backspace" && index > 0 && otp[index] === "") {
            e.preventDefault();
            setOtp((prevOtp) => {
              const newOtp = [...prevOtp];
              newOtp[index - 1] = "";
              return newOtp;
            });
            inputRefs.current[index - 1].current.focus();
          }
        };
        const verify = async (str: string) => {
    
            setLoading(true);

            // await verifyCode(str, method,
            //     user.email,
            //     user.phoneNumber,
            //     user.countryCode
            // ).then((res) => {
            //     console.log(res);
            //     if(res.status === 200) {
            //         const user = JSON.parse(localStorage.getItem("tygo_user")!);
            //         user.token = res.data.token;
            //         user.userId = res.data.userId;
            //         user.tokenExpiryDate = res.data.tokenExpiryDate;
            //         localStorage.setItem("tygo_user", JSON.stringify(user));
            
            //         // setState("card");
            //         navigate('/');
            //     }
            //     setLoading(false);
            // }
            // ).catch((err) => {
            //     setError(err.response.data.Message);
            //     setLoading(false);
            // }
            // );

            if(method === "PhoneNumber") {
                await updatePhoneNumber({
                    "otpCode": str,
                    "phoneNumber": emailOrPhone,
                    "countryCode": "966", // Assuming country code is always 966
                })
                .then((res) => {
                    console.log(res);
                    if(res.status === 200) {
                        const user = JSON.parse(localStorage.getItem("tygo_user")!);
                        user.phoneNumber = emailOrPhone;
                        localStorage.setItem("tygo_user", JSON.stringify(user));
                        setState(false);
                        //notfication
                        toast.success(t("store.otp.phone_update_success") || "Phone number updated successfully");
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setError(err.response.data.message);
                    toast.error(t("store.otp.phone_update_error") || "Failed to update phone number");
                    setLoading(false);
                }
                );
            } else if(method === "Email") {
                await updateEmail({
                    "otpCode": str,
                    "email": emailOrPhone,
                })
                .then((res) => {
                    console.log(res);
                    if(res.status === 200) {
                        const user = JSON.parse(localStorage.getItem("tygo_user")!);
                        user.email = emailOrPhone;
                        localStorage.setItem("tygo_user", JSON.stringify(user));
                        setState(false);
                        //notfication
                        toast.success(t("store.otp.email_update_success") || "Email updated successfully");
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setError(err.response.data.message);
                    toast.error(t("store.otp.email_update_error") || "Failed to update email");
                    setLoading(false);
                }
                );
            }
        }
        // Email
        const Resend = async (typw:string) => {
            const user = JSON.parse(localStorage.getItem("tygo_user")!);
            // createAccount({
            //     firstName:user.name.split(" ")[0],
            //     gander:"Male",
            //     countryCode: "966",
            //     email:user.email,
            //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
            //     registertionType: typw,
            // })
            loginAccount({
                        email:user.email,
                        phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                        countryCode: "966",
                        logintType: typw,}).then(e=>{
                            toast.success(t("store.otp.message"));
                        })
                    
            
            .then(e=>{
                toast.success(t("store.otp.message"));
            })
            .catch(
                (err) => {
                    // loginAccount({
                    //     email:user.email,
                    //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                    //     countryCode: "966",
                    //     logintType: typw,}).then(e=>{
                    //         toast.success(t("Otp Has been sent"));
                    //     })
                    // })
                    // .catch((err) => {
                        setError(err.response.data.message);
                    }
                );
    
        }
    
        useEffect(() => {
            const interval = setInterval(() => {
                setCounter((prev) => {
                    if(prev === 0) {
                        clearInterval(interval);
                        return 60;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(interval);
        }, []);
    
    
        return (
            <div className="card_form">
                <div className="form-group">
                
                <p>{t("store.otp.info")} {emailOrPhone}</p>
                    <div className="my-3 otp_inputs">
                    {otp.map((digit, index) => (
            <input
            //   autoFocus={index === 0 ? true : undefined}
            autoFocus={index === 0 ? true : undefined}
              key={index}
              type="number"
              className="form-control"
              maxLength={1}
              value={digit}
              ref={inputRefs.current[index]}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onChange={(e) => handleOtpChange(index, e.target.value)}
            />
          ))}
                
                    </div>
                </div>
                <p className="text-danger">{error}</p>
                <div className="row my-4">
                    {/* <div className="col-md-6">
                        <Button inner={
                            (counter !== 60 ? counter.toString()+ " "+ t("store.otp.s_to")
                            : "")+ " "+ t("store.otp.resend")}
                             color="secondary" isfullWidth isDisabled={counter!==60}
                         onClick={()=>{
                            Resend("PhoneNumber");
                            const interval = setInterval(() => {
                                setCounter((prev) => {
                                    if(prev === 0) {
                                        clearInterval(interval);
                                        return 60;
                                    }
                                    return prev - 1;
                                });
                            }, 1000);
                            return () => clearInterval(interval);
                            }}
                            />
                    </div>
                    <div className="col-md-6">
                        <Button inner={t("store.otp.to_email")}
                         color="secondary" isfullWidth onClick={()=>{
                            setOtpType("Email");
                            Resend("Email");
                        }} />
                    </div> */}
                </div>
                <Button inner={t("store.otp.submit")}
                 color="primary" isfullWidth onClick={
                    () => {
                        const otpValue = otp.join("");
                        verify(otpValue);
                    }
                 }
                 isLoading={loading} />
            </div>
        );
    
    }